import React from 'react';
import './Header.css';


import logo from '../assets/images/Group 1000005196.png';
import searchIcon from '../assets/icons/Group 1000005151.png';

const Header = () => {
  return (
    <header className="header">
      <div className="header-left">
        <img src={logo} alt="Daily App Hub Logo" className="header-logo" />
        <span className="header-title">Daily App Hub</span>
      </div>
      
      <nav className="nav-menu">
        <a href="#about">About</a>
        <a href="#products">Products</a>
        <a href="#why-us">Why Us</a>
      </nav>

      <div className="header-right">
        <img src={searchIcon} alt="Search" className="search-icon" />
        <button className="contact-button">Contact Us</button>
      </div>
    </header>
  );
};

export default Header;



